import { createSelector } from '@reduxjs/toolkit';
import { ESuburbanWCType, FDealType } from '../../../../packages/JsonQuery';
import { selectDealType } from 'shared/selectors/jsonQuery';

const SUBURBAN_BATHROOM_OPTIONS = [
  { label: 'Неважно', value: null },
  { label: 'На улице', value: ESuburbanWCType.Outside },
  { label: 'В доме', value: ESuburbanWCType.Inside },
];

const SALE_SUBURBAN_BATHROOM_OPTIONS = [
  { label: 'Неважно', value: null },
  { label: 'Только в доме', value: ESuburbanWCType.Inside },
];

export const selectSuburbanBathroomOptions = createSelector(selectDealType, dealType => {
  if (dealType === FDealType.Sale) {
    return SALE_SUBURBAN_BATHROOM_OPTIONS;
  }

  return SUBURBAN_BATHROOM_OPTIONS;
});
